import styled from 'styled-components';

const SubHeaderContainer = styled.div`
  position: relative;
  top: -10px;
  margin-top: ${({ theme }) => theme.spacing(3)};
  background: ${({ theme }) => theme.colors.white};
  z-index: ${({ theme }) => theme.constants.zIndex.secondHeader};
`;

export default SubHeaderContainer;
